// apps/conext-ventas/src/utils/cpCity.js

/**
 * Normaliza un nombre de ciudad para usar como sufijo de lista.
 * Ej: "A Coruña" → "a_coruna", "L'Hospitalet de Llobregat" → "l_hospitalet_de_llobregat"
 */
export function normalizeCityName(city) {
  if (!city || typeof city !== "string") return "";
  return city
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/['\s\-]+/g, "_")
    .replace(/[^a-z0-9_]/g, "");
}

/**
 * Consulta zippopotam.us para obtener el nombre de ciudad dado un CP español.
 * Lanza error si el CP no existe o la red no responde en 5s.
 * @param {string} cp - Código postal de 5 dígitos
 * @returns {Promise<string>} Nombre de ciudad (ej: "Valencia")
 */
export async function fetchCityByCP(cp) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);
  try {
    const res = await fetch(`https://api.zippopotam.us/es/${cp}`, {
      signal: controller.signal,
    });
    if (!res.ok) throw new Error(`CP no encontrado: ${cp}`);
    const data = await res.json();
    const city = data?.places?.[0]?.["place name"];
    if (!city) throw new Error("Sin ciudad en respuesta");
    return city;
  } finally {
    clearTimeout(timeout);
  }
}
